<template>
  <div class="tixstock-search-container">
    <div class="tixstock-search-box" :class="{
      active: isFocused || search.length > 0,
      'tixstock-search-no-border': search.length > 0 && searchDiv,
      'tixstock-search-border': !(search.length > 0 && searchDiv)
    }">
      <svg class="tixstock-search-icon" viewBox="0 0 24 24">
        <path
          d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      </svg>

      <input type="text" v-model="search" placeholder="Event, artist or team" class="tixstock-search-input"
        @focus="onFocus" @blur="onBlur" />

        <div v-if="search.length > 0" @click="clearSearch" class="close-search">
         <img src="@/assets/images/tixstockcategories/icons/searchClose.svg" height="20px" />
        </div>
    </div>

    <div v-if="search.length > 0 && searchDiv" class="tixstock-search-results">
      <div v-if="loading" class="tixstock-loader">Loading...</div>

      <div v-else class="tixstock-results-content">

        <!-- Categories -->
        <div class="tixstock-section" v-if="categories.length">
          <h3 class="pl-16 pr-16">Categories</h3>
          <p
            v-for="cat in categories"
            :key="cat.id"
            @click="onItemClick(cat , 'category')"
            class="mb-5 search-link pl-16 pr-16"
          >
            {{ getName(cat) }}
          </p>
        </div>

        <!-- Events -->
        <div class="tixstock-section" v-if="events.length">
          <h3 class="pl-16 pr-16">Events</h3>

          <div
            class="tixstock-event-item search-link "
            v-for="event in events"
            :key="event.id"
            @click="onItemClick(event, 'event')"
            
          >
            <div class="tixstock-event-name pl-16 pr-16">
              {{ getName(event) }}
            </div>
            <div class="tixstock-event-date pl-16 pr-16">{{ formatDate(event.datetime) }}</div>
            <div class="tixstock-event-venue pl-16 pr-16">{{ event.venue && event.venue.name }}</div>
          </div>

          <a class="tixstock-more pl-16 pr-16 pt-10 pb-10 mt-0" @click="onMoreClick( 'event', search)">More events</a>
        </div>

        <!-- Venues -->
        <div class="tixstock-section" v-if="venues.length">
          <h3 class="pl-16">Venues</h3>

          <div
            class="tixstock-venue-item search-link"
            v-for="venue in venues"
            :key="venue.id"
            @click="onItemClick(venue , 'venue')"
          >
            <strong class="pl-16 pr-16">{{ getName(venue) }}</strong>
            <p class="pl-16 pr-16 mb-5">{{ venue.events.length || 0 }} upcoming events</p>
            <p class="pl-16 pr-16 mb-5">{{ venue.address }}</p>
          </div>

          <a class="tixstock-more pl-16 pr-16 pt-10 pb-10 mt-0"  @click="onMoreClick( 'venue', search)" >
            More venues
            
          </a>
        </div>
        <div class="tixstock-section" v-if="performers.length">
          <h3 class="pl-16">Performers</h3>

          <div class="tixstock-venue-item search-link" v-for="performer in performers" :key="performer.id"
            @click="onItemClick(performer, 'performer')">
            <strong class="pl-16 pr-16">{{ getName(performer) }}</strong>
          </div>
        </div>

        <div  class="tixstock-no-results" v-if="!categories.length && !events.length && !venues.length && !performers.length">
          No results found
        </div>

      </div>
    </div>
   
  </div>
</template>


<script>
import { FETCH_GENERAL_SEARCH } from "@/store/actions.type";
import moment from 'moment'
export default {
  data() {
    return {
      search: "",
      isSearch: false,
      isFocused: false,
      loading: false,
      debounceTimer: null,
      searchDiv:false,

      categories: [],
      events: [],
      venues: [],
      performers:[]
    };
  },

  watch: {
    search(newVal) {
      this.searchDiv = true;
      clearTimeout(this.debounceTimer);

      if (!newVal || newVal.length < 2) {
        this.categories = [];
        this.events = [];
        this.venues = [];
        this.performers = []
        this.loading = false;
        return;
      }

      this.loading = true;

      this.debounceTimer = setTimeout(() => {
        this.searchResults();
      }, 600);
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    onMoreClick(type, search) {
      this.$router.push({ name: 'internationalEventFind', query: { type, search } });
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.isFocused = false;
        this.searchDiv = false;
      }
    },
    onFocus() {
      this.isFocused = true;
    },
    clearSearch() {
      this.search = '';
      this.categories = [];
      this.events = [];
      this.venues = [];
      this.performers = []
      this.searchDiv = false;
    },

    onBlur() {
      setTimeout(() => {
        this.isFocused = false;
      }, 200);
    },

    getName(item) {
      return item.displayName || item.name || "";
    },

    onItemClick(item, type) {
       this.$router.push(`/international/event/${item.id}?type=${type}`);
    },
    formatDate(d) {
      return moment(d).format("ddd, DD MMM YYYY");
    },

    searchResults() {
      const url = `/tixstock/generalSearch?search=${this.search}`;
      this.$store
        .dispatch(FETCH_GENERAL_SEARCH, { url })
        .then((res) => {
          const data = res.data || {};

          this.categories = data.categories || [];
          this.events = data.events || [];
          this.venues = data.venues || [];
          this.performers = data.performers || []
          this.searchDiv = true

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>


<style scoped>
    .tixstock-no-results {
      padding: 20px;
      text-align: center;
      color: #666;
      font-size: 14px;
    }
.tixstock-search-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  background: white;
}

.tixstock-search-border {
  border: 1px solid #ddd;
  border-radius: 20px;
}

.tixstock-search-no-border {
  border: none;
  border-radius: 0;
}

.tixstock-search-box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: white;
  transition: border 0.3s;
  position: relative;
  z-index: 5;
}

.tixstock-search-icon {
  width: 20px;
  height: 20px;
  fill: #666;
  margin-right: 12px;
  flex-shrink: 0;
}

.tixstock-search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
}
.tixstock-search-results {
  position: absolute;
  left: -6px;
  right: 0;
  top: -3px;
  width: calc(100% + 9px);
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 20px;
  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2;
  padding-top: 62px;
}

.tixstock-loader {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 14px;
}

.tixstock-results-content {
}

.tixstock-section {
  margin-bottom: 24px;
}

.tixstock-section h3 {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
}

.tixstock-event-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.tixstock-event-name {
  font-weight: 600;
  font-size: 15px;
}

.tixstock-event-date,
.tixstock-event-venue {
  font-size: 14px;
  color: #666;
}

.tixstock-more {
  display: block;
  margin-top: 12px;
  color: #000 !important;
  font-size: 14px;
  text-decoration: none;
}
.tixstock-more:hover {
  cursor: pointer;
  background: #000;
  color: #fff !important;
}
.search-link{
  cursor: pointer;
  padding-top:5px;
  padding-bottom:5px
}
.search-link:hover{
  background: #000;
  color: #fff
}
.search-link:hover .tixstock-event-date{
  color: #fff
}
.search-link:hover .tixstock-event-venue{
    color: #fff

}
.close-search{
  cursor:pointer;
}
</style>
